export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_50-8d73d7b2829fb3f58b2142bc674f0c7a.jpg";